import styled from 'styled-components';

export const Container = styled.div`
  padding: 30px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0;
`;

export const ContentCard = styled.div`
  padding: 30px;
  padding-bottom: 60px; /* Ensure whitespace at bottom */

  @media (max-width: 768px) {
    padding: 12px;
    padding-bottom: 40px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const VideosSection = styled.div`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const SectionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SectionIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(250, 70, 22, 0.1)'
      : 'rgba(250, 70, 22, 0.08)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fa4616;
`;

export const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0;
`;

export const SectionDescription = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 0;
`;

export const SeeAllButton = styled.button`
  background: none;
  border: none;
  color: #fa4616;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(250, 70, 22, 0.1)'
        : 'rgba(250, 70, 22, 0.08)'};
  }
`;

export const VideosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WhatsNewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;

    & > * {
      flex: 0 0 85%;
      scroll-snap-align: start;
    }
  }
`;

export const TopicFiltersWrapper = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const TopicFilters = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 12px;
  position: relative;

  /* Custom styled scrollbar for better UX when there are many topics */
  scrollbar-width: thin;
  scrollbar-color: ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.3)'
        : 'rgba(0, 0, 0, 0.3)'}
    transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.3)'
        : 'rgba(0, 0, 0, 0.3)'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.4)'
        : 'rgba(0, 0, 0, 0.4)'};
  }

  /* Smooth scrolling */
  scroll-behavior: smooth;
`;

export const ScrollHint = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: ${(props) => (props.show ? 'flex' : 'none')};
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  margin-left: 12px;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(250, 70, 22, 0.2)'
      : 'rgba(250, 70, 22, 0.15)'};
  border: 1px solid rgba(250, 70, 22, 0.4);
  border-radius: 20px;
  color: #fa4616;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  pointer-events: none;
  animation: pulse 2s ease-in-out infinite;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(250, 70, 22, 0.2);
  white-space: nowrap;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const WhatsNewContainer = styled.div`
  margin-bottom: 40px;
  padding: 28px;
  border-radius: 16px;
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  background: ${(props) =>
    props.theme?.name === 'dark' ? '#1e1e38' : '#ffffff'};

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const WhatsNewHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const WhatsNewIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fa4616;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const WhatsNewInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const WhatsNewTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => (props.theme?.name === 'dark' ? '#ffffff' : '#0F172A')};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NewBadge = styled.span`
  padding: 4px 10px;
  background: #fa4616;
  color: white;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const WhatsNewDescription = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme?.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 0;
`;
